import React from 'react';
import { HardHat, CheckCircle, AlertCircle } from 'lucide-react';

export const About: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-xl p-8">
      <div className="flex items-center justify-center mb-8">
        <HardHat className="h-12 w-12 text-blue-600 mr-4" />
        <h2 className="text-3xl font-bold text-slate-800">About Our Calculator</h2>
      </div>

      <div className="prose max-w-none">
        <div className="mb-8">
          <h3 className="text-2xl font-semibold text-slate-800 mb-4">Professional Construction Tool</h3>
          <p className="text-slate-600 leading-relaxed">
            Our asphalt calculator is designed to provide construction professionals with accurate 
            tonnage estimates for asphalt paving projects. Using industry-standard calculations and 
            proven methodologies, this tool helps you plan your material requirements with precision.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div className="bg-blue-50 rounded-lg p-6">
            <h4 className="text-xl font-semibold text-slate-800 mb-4 flex items-center">
              <CheckCircle className="h-6 w-6 text-green-600 mr-2" />
              Calculation Basis
            </h4>
            <ul className="space-y-2 text-slate-600">
              <li>• Standard unit weight: 110 LB/(SY*INCH)</li>
              <li>• Precise decimal calculations</li>
              <li>• Industry-approved formulas</li>
              <li>• Professional-grade accuracy</li>
            </ul>
          </div>

          <div className="bg-amber-50 rounded-lg p-6">
            <h4 className="text-xl font-semibold text-slate-800 mb-4 flex items-center">
              <AlertCircle className="h-6 w-6 text-amber-600 mr-2" />
              Important Notes
            </h4>
            <ul className="space-y-2 text-slate-600">
              <li>• Results are estimates only</li>
              <li>• Actual weights may vary</li>
              <li>• Consider local conditions</li>
              <li>• Consult with professionals</li>
            </ul>
          </div>
        </div>

        <div className="bg-slate-50 rounded-lg p-6">
          <h3 className="text-2xl font-semibold text-slate-800 mb-4">Professional Use</h3>
          <p className="text-slate-600 leading-relaxed mb-4">
            While our calculator provides accurate estimates based on industry standards, we recommend using 
            these calculations as part of a comprehensive project planning process. Always consult with 
            local contractors and engineers for final material specifications.
          </p>
          <p className="text-slate-600 leading-relaxed">
            For the most accurate results, consider factors such as:
          </p>
          <ul className="list-disc pl-6 mt-2 text-slate-600 space-y-2">
            <li>Local material specifications</li>
            <li>Compaction requirements</li>
            <li>Temperature conditions</li>
            <li>Surface preparation needs</li>
          </ul>
        </div>
      </div>
    </div>
  );
};